import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { setUserLogout } from '../../../actions/logout'
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import AdminDashboard from '../../../components/siteadmin/AdminDashboard';
import Loader from '../../../components/Loader';

import UserDashboard from './UserDashboard.graphql';
import ListingDashboard from './ListingDashboard.graphql';
import ReservationDashboard from './ReservationDashboard.graphql';
import GetAdminUser from './GetAdminUser.graphql'

const Dashboard = (props) => {
    const dispatch = useDispatch();
    const [dateFilter, setDateFilter] = useState({
        startDate: null,
        endDate: null,
        filterOption: null
    });
    const [hasLoaded, setHasLoaded] = useState(false);

    const { data: userData, loading: userLoading, refetch: refetchUser } = useQuery(UserDashboard, {
        fetchPolicy: 'network-only',
        ssr: false,
        notifyOnNetworkStatusChange: true,
        variables: {
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            filterOption: dateFilter.filterOption
        }
    });

    const { data: listingData, loading: listingLoading, refetch: refetchListing } = useQuery(ListingDashboard, {
        fetchPolicy: 'network-only',
        ssr: false,
        notifyOnNetworkStatusChange: true,
        variables: {
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            filterOption: dateFilter.filterOption
        }
    });

    const { data: reservationData, loading: reservationLoading, refetch: refetchReservation } = useQuery(ReservationDashboard, {
        fetchPolicy: 'network-only',
        ssr: false,
        notifyOnNetworkStatusChange: true,
        variables: {
            startDate: dateFilter.startDate,
            endDate: dateFilter.endDate,
            filterOption: dateFilter.filterOption
        }
    });

    const { data: adminUserData, loading: adminLoading } = useQuery(GetAdminUser, {
        fetchPolicy: 'network-only',
        ssr: false,
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        if (adminUserData && adminUserData.getAdminUser === null) {
            dispatch(setUserLogout({ isAdmin: true }))
        }
    }, [adminUserData, dispatch]);

    useEffect(() => {
        if (!userLoading && !listingLoading && !reservationLoading && !adminLoading) {
            setHasLoaded(true);
        }
    }, [userLoading, listingLoading, reservationLoading, adminLoading]);

    const handleDateFilterChange = (startDate, endDate, filterOption) => {
        setDateFilter({
            startDate: startDate ? startDate.format('YYYY-MM-DD') : null,
            endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
            filterOption: filterOption || null
        });
    };

    if (!hasLoaded) {
        return <Loader type={"text"} />;
    } else if (adminUserData && adminUserData.getAdminUser === null) {
        return (
            <div>
                <Loader type={"text"} />
            </div>
        )
    }

    const getUserDataProps = { ...userData, loading: userLoading, refetch: refetchUser };
    const getListingDataProps = { ...listingData, loading: listingLoading, refetch: refetchListing };
    const getReservationDataProps = { ...reservationData, loading: reservationLoading, refetch: refetchReservation };

    return <AdminDashboard
        user={getUserDataProps}
        listing={getListingDataProps}
        reservation={getReservationDataProps}
        onDateFilterChange={handleDateFilterChange}
        adminUserData={adminUserData}
    />;
}

export default Dashboard;
